import {
  Col, Input,
  Pagination, Row, Skeleton, Table
} from "antd";
import { useEffect, useState } from "react";
import { FaEye, FaSearch } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { Get } from "../../config/api/get";
import { PAYMENT } from "../../config/constants/api";
import { useSelector } from "react-redux";
// import moment from "moment";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import { useDebouncedCallback } from "use-debounce";

const PaymentLogs = () => {
  dayjs.extend(timezone);
  dayjs.extend(utc);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [payments, setPayments] = useState(null);
  const token = useSelector((state) => state.user.userToken);
  const [paginationConfig, setPaginationConfig] = useState({
    pageNumber: 1,
    limit: 10,
    totalDocs: 0,
    totalPages: 0,
  });
  const [filter, setFilter] = useState({
    status: null,
    type: null,
    keyword: "",
    from: null,
    to: null,
  });
  const getUsers = (pageNumber, pageSize, from, to, status, keyword) => {
    setLoading(true);
    Get(PAYMENT.getAllBookingPayments, token, {
      from,
      to,
      keyword,
      status,
      page: pageNumber
        ? pageNumber.toString()
        : paginationConfig.pageNumber.toString(),
      limit: pageSize ? pageSize.toString() : paginationConfig.limit.toString(),
    })
      .then((response) => {
        if (response?.data?.docs) {
          setPayments(response?.data?.docs);
          setPaginationConfig({
            pageNumber: response?.data?.page,
            limit: response?.data?.limit,
            totalDocs: response?.data?.totalDocs,
            totalPages: response?.data?.totalPages,
          });
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log("Error Fetching Loads", err);
        setLoading(false);
      });
  };
  useEffect(() => {
    getUsers();
    // eslint-disable-next-line
  }, []);
  const startIndex =
    (paginationConfig.pageNumber - 1) * paginationConfig.limit + 1;
  const endIndex = Math.min(
    startIndex + paginationConfig.limit - 1,
    paginationConfig.totalDocs
  );
  // const message = `Showing records ${endIndex} of ${paginationConfig.totalDocs}`;
  const message = payments
    ? `Showing records ${endIndex} of ${paginationConfig.totalDocs}`
    : "Showing records 0 of 0";
  // const resetFilter = () => {
  //   setFilter({
  //     status: null,
  //     keyword: "",
  //     from: null,
  //     to: null,
  //   });
  // };
  // const handleFrom = (date) => {
  //   setFilter({
  //     ...filter,
  //     from: date,
  //   });
  // };
  const handlePageChange = (pageNumber) => {
    setPaginationConfig({
      ...paginationConfig,
      pageNumber: pageNumber,
    });
    getUsers(pageNumber, paginationConfig.limit);
  };
  // const handleTo = (date) => {
  //   setFilter({
  //     ...filter,
  //     to: date,
  //   });
  // };
  // const data = {
  //   status: filter.status,
  //   keyword: filter.keyword,
  //   from: filter.from,
  //   to: filter.to,
  // };
  // const handleApply = () => {
  //   let from;
  //   let to;
  //   let status = data.status;
  //   if (data.from) {
  //     from = moment(filter?.from?.$d).format("YYYY-MM-DD");
  //   }
  //   if (data.to) {
  //     to = moment(filter?.to?.$d).format("YYYY-MM-DD");
  //   }
  //   if (from || to || status) {
  //     getUsers(
  //       paginationConfig.pageNumber,
  //       paginationConfig.limit,
  //       from,
  //       to,
  //       status
  //     );
  //   } else {
  //     return;
  //   }
  // };
  // const handleClear = () => {
  //   resetFilter();
  //   getUsers();
  // };
  // const handleStatusChange = (value) => {
  //   setFilter({
  //     ...filter,
  //     status: value,
  //   });
  // };

  const handleSearch = useDebouncedCallback((value) => {
    setFilter({
      ...filter,
      keyword: value,
    });
    getUsers(
      paginationConfig.pageNumber,
      paginationConfig.limit,
      null,
      null,
      null,
      value
    );
  }, 1000);

  // const filterContent = (
  //   <div className="filterDropdown">
  //     <div>
  //       <p
  //         className="mainLabel"
  //         style={{ padding: "10px", fontSize: "18px", fontWeight: "bold" }}
  //       >
  //         Filter
  //       </p>
  //     </div>
  //     <hr style={{ marginBottom: 10 }} />

  //     <div className="filterDropdownBody">
  //       <p className="mainLabel">From:</p>
  //       <DatePicker
  //         className="mainInput filterInput web-input"
  //         value={filter.from}
  //         onChange={(e) => handleFrom(e)}
  //         style={{ width: "100%" }}
  //       />
  //       <p className="mainLabel">To:</p>
  //       <DatePicker
  //         className="mainInput filterInput web-input"
  //         value={filter.to}
  //         onChange={(e) => handleTo(e)}
  //         style={{ width: "100%" }}
  //       />

  //       <p className="mainLabel"> Status:</p>

  //       <Select
  //         size={"large"}
  //         className="filterSelectBox"
  //         placeholder="Select Status"
  //         value={filter.status}
  //         onChange={(e) => handleStatusChange(e)}
  //         style={{
  //           width: "100%",
  //           marginBottom: "10px",
  //           textAlign: "left",
  //         }}
  //         options={[
  //           { value: "PENDING", label: "Pending" },
  //           { value: "PAID", label: "paid" },
  //           { value: "UPCOMING", label: "Upcoming" },
  //           { value: "ONGOING", label: "Ongoing" },
  //           { value: "ARRIVED", label: "Arrived" },
  //           { value: "COMPLETED", label: "Completed" },
  //         ]}
  //       />

  //       <Button
  //         type=""
  //         block
  //         size={"large"}
  //         style={{ marginBottom: "10px" }}
  //         className="web-btn"
  //         //   onClick={() => getUsers()}
  //         onClick={handleApply}
  //       >
  //         Apply
  //       </Button>
  //       <Button
  //         type=""
  //         block
  //         size={"large"}
  //         className="web-btn"
  //         onClick={handleClear}
  //       >
  //         Clear All
  //       </Button>
  //     </div>
  //   </div>
  // );
  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return (
        <button type="button" className="pagination-link">
          Previous
        </button>
      );
    }
    if (type === "next") {
      return (
        <button type="button" className="pagination-link">
          Next
        </button>
      );
    }

    return originalElement;
  };

  const columns = [
    {
      title: (
        <p className="uppercase font-euclid text-black font-bold text-sm text-center">
          S.NO
        </p>
      ),
      dataIndex: "key",
      key: "key",
      render: (value, item, index) => (
        <p className="text-sm text-center font-euclid text-[#575757]">
          {(index < 10 && "0") + (index + 1)}
        </p>
      ),
    },
    {
      title: (
        <p className="uppercase font-euclid text-black font-bold text-sm text-center">
          Booking id
        </p>
      ),
      dataIndex: "_id",
      key: "bookingId",
      render: (value, item, index) => (
        <p className="text-sm text-center font-euclid text-[#575757]">
          {"#" + value.slice(-4)}
        </p>
      ),
    },
    {
      title: (
        <p className="uppercase font-euclid text-black font-bold text-sm text-center">
          Client Name
        </p>
      ),

      dataIndex: "user",
      key: "user",
      render: (value, item, index) => (
        <p className="text-sm text-center font-euclid text-[#575757]">
          {value?.firstName ? value?.firstName + " " + value?.lastName:'-'}
        </p>
      ),
    },
    {
      title: (
        <p className="uppercase font-euclid text-black font-bold text-sm text-center">
          Chauffeur Name
        </p>
      ),
      // dataIndex: "ChauffeurName",
      // key: "ChauffeurName",
      // render: (value, item, index) => (
      //   <p className="text-sm text-center font-euclid text-[#575757]">
      //     {item.chauffeurName}
      //   </p>
      // ),
      dataIndex: "chauffeur",
      key: "chauffeur",
      render: (value, item, index) => (
        <p className="text-sm text-center font-euclid text-[#575757]">
          {value?.firstName ? value?.firstName + " " + value?.lastName : "-"}
        </p>
      ),
    },
    {
      title: (
        <p className="uppercase font-euclid text-black font-bold text-sm text-center">
          Car Type
        </p>
      ),
      dataIndex: ["booking", "serviceType"],
      key: "serviceType",
      render: (value, item, index) => (
        <p className="text-sm text-center font-euclid text-[#575757]">
          {value}
        </p>
      ),
    },
    {
      title: (
        <p className="uppercase font-euclid text-black font-bold text-sm text-center">
          Total Amount Paid
        </p>
      ),
      dataIndex: "totalAmount",
      key: "totalAmount",
      render: (value, item, index) => (
        <p className="text-sm text-center font-euclid text-[#575757]">
          ${value}
        </p>
      ),
    },
    // {
    //   title: (
    //     <p className="uppercase font-euclid text-black font-bold text-sm text-center">
    //     Chauffeur Commission
    //     </p>
    //   ),
    //   dataIndex: "chauffeurCommission",
    //   key: "chauffeurCommission",
    //   render: (value, item, index) => (
    //     <p className="text-sm text-center font-euclid text-[#575757]">
    //       {item.chauffeurCommission}
    //     </p>
    //   ),
    // },

    {
      title: (
        <p className="uppercase font-euclid text-black font-bold text-sm text-center">
          Date
        </p>
      ),
      dataIndex: "createdAt",
      key: "createdAt",
      render: (item) => <span>{dayjs.tz(item, "UTC").format("M/D/YYYY")}</span>,
    },

    // {
    //   title: "Status",
    //   dataIndex: "status",
    //   key: "status",
    //   render: (item) => (
    //     <>
    //       {item === "UPCOMING" ? (
    //         <span style={{ color: "#DD9F00" }}>{item}</span>
    //       ) : item === "UNPAID" ? (
    //         <span style={{ color: "#ff0000" }}>{item}</span>
    //       ) : item === "PAID" ? (
    //         <span style={{ color: "#00D640" }}>{item}</span>
    //       ) : (
    //         <span>{item}</span>
    //       )}
    //     </>
    //   ),
    // },

    {
      title: (
        <p className="uppercase font-euclid text-black font-bold text-xs text-center">
          action
        </p>
      ),
      dataIndex: "_id",
      key: "_id",
      render: (value, item, index) => (
        <div className="flex justify-center">
          <div className="flex justify-center bg-[#9CFEC4] rounded-[100%] w-fit p-2">
            <FaEye
              className="text-[#089B44] cursor-pointer h-[16px] w-[16px]"
              onClick={() =>
                navigate("/paymentLogDetails/", { state: { data: item } })
              }
              // onClick={() => navigate("/paymentLogDetails/" + item._id)}
            />
            {/* <RiEdit2Fill
              className="text-[#089B44] cursor-pointer h-[16px] w-[16px]"
              onClick={() => navigate("/editUser/" + item._id)}
            /> */}
          </div>
        </div>
      ),
    },
  ];
  return (
    <Row justify="center">
      <Col md={23} xs={22}>
        <div className="flex max-md:flex-col max-md:items-start justify-between items-center my-8">
          <h3 className="font-tavi laptop:text-3xl text-xl font-normal text-black md:ml-8 max-md:mb-2">
            Payment Logs
          </h3>
          <div className="flex justify-center items-center max-md:w-full max-md:justify-end">
            <Input
              className="mainInput dashInput h-full w-[250px] max-md:max-w-[150px]"
              placeholder="Search"
              onChange={(e) => handleSearch(e.target.value)}
              suffix={
                <FaSearch
                  style={{
                    color: "#818181",
                    fontSize: 16,
                    cursor: "pointer",
                  }}
                  //   onClick={() =>
                  //     getUsers(1, paginationConfig.limit, filter.keyword)
                  //   }
                />
              }
              //   onPressEnter={(e) =>
              //     getUsers(1, paginationConfig.limit, filter.keyword)
              //   }
            />
            &emsp;
            {/* <div className="flex justify-center">
              <Popover
                //   content={filterContent}
                trigger="click"
                //   open={open}
                //   onOpenChange={handleOpenChange}
                placement="bottomRight"
                arrow={false}
              >
                <Button
                  style={{
                    padding: "4px 11px",
                    height: "auto",
                    borderRadius: "6px",
                    backgroundColor: "white",
                  }}
                >
                  <MdTune className="text-[32px] text-[#767676]" />
                </Button>
              </Popover>
            </div> */}
          </div>
        </div>
        <div
          className="bg-white rounded-lg  py-8 my-8"
          style={{ boxShadow: "1px 1px 1px 1px rgba(0, 0, 0, 0.05)" }}
        >
          <Row style={{ overflow: "auto" }} className="px-6">
            {loading ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <Skeleton active />
                <br />
              </div>
            ) : (
              <Table
                className="styledTable"
                // dataSource={paymentLogs}
                dataSource={payments}
                columns={columns}
                pagination={false}
              />
            )}
          </Row>
          <Row style={{ padding: "10px 20px" }}>
            <Col xs={24} md={12}>
              <p className="font-euclid text-sm text-black">{message}</p>
            </Col>
            <Col
              xs={24}
              md={12}
              style={{ display: "flex", justifyContent: "flex-end" }}
            >
              <Pagination
                className="styledPagination"
                onChange={(e) => handlePageChange(e)}
                current={parseInt(paginationConfig.pageNumber)}
                pageSize={paginationConfig.limit}
                total={paginationConfig.totalDocs}
                itemRender={itemRender}
              />
            </Col>
          </Row>
        </div>
      </Col>
    </Row>
  );
};

export default PaymentLogs;
